import React from 'react';
import '../css/background.css';
import { useParams } from 'react-router-dom';
import { useIsJCUser } from '@hooks/user.hook';
import { subjectIdFromName } from '@utils/helpers/SubjectParser';

export const BackgroundContainer = (props: React.HTMLProps<HTMLDivElement>) => {
  const params = useParams();
  const { isJC } = useIsJCUser({
    subjectId: subjectIdFromName(params.subjectId || ''),
  });
  return (
    <div
      {...props}
      className={`container-bg relative ${
        isJC === false
          ? "bg-[url('/src/assets/background/Background_Default_1.svg')]"
          : ''
      }
        bg-primary-navyblue-dark
        bg-center bg-no-repeat bg-fixed bg-cover
        h-[calc((100*var(--vh,vh))-64px)]
        overflow-auto no-scrollbar
        ${props.className && props.className}`}
    >
      {props.children && props.children}
    </div>
  );
};
